import { ClickEvent, Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCarrierCallinHistoryList } from "./autogen/AutogenLayoutCarrierCallinHistoryList";
import { ModelRow, Navigation, StringUtil } from "@mcleod/core";
import { OrderTabView } from "./OrderTabView";
import { PlanningUtil } from "./planning/PlanningUtil";

export class CarrierCallinHistoryList extends AutogenLayoutCarrierCallinHistoryList {

    orderNumberOnClick(event: ClickEvent) {
        const orderOrManifestId = (event.target as Label)?.text;
        if (!StringUtil.isEmptyString(orderOrManifestId)) {
            if (orderOrManifestId?.startsWith("M")) {
                Navigation.navigateTo("lme/dispatch/OrderList?manifest_id=" + orderOrManifestId, { newTab: true });
            } else {
                OrderTabView.navigateTo({ key: orderOrManifestId, newTab: true });
            }
        }
    }

    tableCarrierCallinHistOnRowDisplay(event: TableRowDisplayEvent){
        const tableRow = event.getTableRow();
        const modelRow = tableRow?.data as ModelRow;
        const orderIdLabel = tableRow.findComponentById("labelOrderNumber") as Label;
        if (orderIdLabel != null && !StringUtil.isEmptyString(orderIdLabel.text)) {
            if (orderIdLabel.text?.startsWith("M")) {
                orderIdLabel.tooltip = "Click to view manifest";
            } else {
                orderIdLabel.tooltip = "Click to view order";
            }
            orderIdLabel.applyLinkStyle();
        }

        const labelStops = tableRow.findComponentById("labelStops") as Label;
        if (labelStops != null) {
            const picks = modelRow.getNumber("extra_pickups", 0) + 1;
            const drops = modelRow.getNumber("extra_deliveries", 0) + 1;
            labelStops.text = `${picks} pick${picks > 1 ? "s": ""},\n${drops} drop${drops > 1 ? "s": ""}`;
        }
    }

    labelStopsOnClick(event: ClickEvent) {
        const label = event.target as Label;
        const tableRow = TableRow.getContainingTableRow(label);
        const modelRow = tableRow?.data as ModelRow;
        const orderId = modelRow?.get("order_id") as string;
        if (!StringUtil.isEmptyString(orderId)) {
            PlanningUtil.showMultiStopSlideout(label, false, orderId);
        }
    }
}
